import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconImage16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconImage16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13 3H3a1 1 0 0 0-1 1v5.023l3.726-2.441.303-.199.283.227 4.766 3.812L14 9.17V4a1 1 0 0 0-1-1m2 6.49V4a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2zm-1 .768-2.803 1.202-.275.118-.234-.188L5.97 7.617l-3.84 2.516a.5.5 0 0 1-.131.06V12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1zM10.75 7a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 1a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconImage16);
